// extracted by mini-css-extract-plugin
export default {"confirmContainer":"styles_confirmContainer__PEp4Q","backButtonContainer":"styles_backButtonContainer__ziZth","buttonContainer":"styles_buttonContainer__Q3vC6"};